// Object
export const isObject = (x: unknown) => typeof x === 'object' && !Array.isArray(x) && x !== null;
export const isEmptyObject = (x: object) => isObject(x) && Object.keys(x).length === 0;
export const getKeys = <T extends object>(obj: T) => Object.keys(obj) as (keyof T)[];


// Array

export const isArray = (x: unknown) => Array.isArray(x);


// Function

export const isFunction = (x: unknown) => typeof x === 'function';


// String

export const isString = (x: unknown) => typeof x === 'string' || x instanceof String;